import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hsl",
  "use": "icon-hsl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hsl\"><path d=\"M27.648 854.016L256 512 27.648 169.984h171.008L427.008 512 198.656 854.016H27.648z\" fill=\"#6D6DF7\" /><path d=\"M256 854.016L484.352 512 256 169.984h171.008l456.704 683.008H710.656L569.344 640 427.008 854.016H256z\" fill=\"#CE5EEA\" /><path d=\"M805.888 654.336l-75.776-114.688h266.24v114.688H805.888zM692.224 484.352l-75.776-114.688h378.88v114.688H692.224z\" fill=\"#E595E5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol